import { Endpoints, fetcher } from './utils';
import type { TenantLookupResponse } from '../shared/types';

export async function lookupTenant(
  userEmail: string,
  workflowId?: string,
): Promise<TenantLookupResponse> {
  return fetcher(Endpoints.TENANT_LOOKUP_BY_DOMAIN, {
    method: 'POST',
    body: JSON.stringify({ userEmail }),
    workflowId,
  });
}
